const assetsSelectors = {
	getAssetBuildUrl: state => state.assets.buildUrl || null,
};

export default assetsSelectors;
